import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';
import {
  MedicalRequest,
  MedicalRequestBox,
  MedicalRequestNotes,
} from 'src/app/_models/PSP/medical-requests.model';
import { Pharmacy } from 'src/app/_models/PSP/pharmacy.model';
import { MedicationRequestService } from 'src/app/_services/PSP/medication-request.service';
import { PharmaciesService } from 'src/app/_services/PSP/pharmacies.service';
import { NearestPharmacyModalComponent } from '../../nearest-pharmacy-modal/nearest-pharmacy-modal.component';
import { CancelRequestModalComponent } from '../cancel-request-modal/cancel-request-modal.component';
import { PreviewDocumentsModalComponent } from '@components/preview-documents-modal/preview-documents-modal.component';

@Component({
  selector: 'app-request-details',
  templateUrl: './request-details.component.html',
  styleUrls: ['./request-details.component.scss'],
})
export class RequestDetailsComponent implements OnInit {
  request: MedicalRequest;
  pharmacyList: Pharmacy[] = [];
  selectedPharmacy;
  searchPharmacyStep = 1;
  nationalIdAndPassportId: string = '';
  modalRef: BsModalRef;
  isInsulinProgram = false;
  constructor(
    private medicalRequestService: MedicationRequestService,
    private modalService: NgbModal,
    private pharmacyService: PharmaciesService,
    private toastr: ToastrService,
    private bsModalService: BsModalService
  ) {}

  ngOnInit(): void {
    this.medicalRequestService
      .getSelectedRequest()
      .subscribe((request: MedicalRequest) => {
        if (!request) {
          window.history.back();
          // document.referrer;
          // showNotification('danger', 'Please select correct request', this.toastr)
          // this.router.navigate(['/psp/medication/home-delivery']);
        } else {
          this.request = request;
          this.nationalIdAndPassportId = `${
            this.request.patient.nationalId ?? ''
          } ${
            this.request.patient.nationalId && this.request.patient.passportId
              ? '/'
              : ''
          } ${this.request.patient.passportId ?? ''}`;
          this.isInsulinProgram = this.medicalRequestService.isInsulinRequest(
            this.request?.programName
          );

          if (request.typeId == 1 && request.statusId == 1) {
            this.pharmacyService
              .getPspPharmaciesByAreaId(
                this.request?.patientAddressData?.area?.id,
                this.isInsulinProgram
              )
              .subscribe((res) => {
                this.pharmacyList = res?.data?.pharmacies;
              });
          }
        }
      });
  }

  routeToSelectPharmacy(): void {
    this.medicalRequestService.setSelectedRequest(this.request);

    if (this.request.patientAddressData.area.id) {
      this.openModal();
    }
    // this.router.navigate(['/psp/medication/select-pharmacy']);
  }

  openModal(modal = NearestPharmacyModalComponent, size = 'lg'): void {
    const modalRef = this.modalService.open(modal, {
      size,
      backdrop: 'static',
      animation: true,
      centered: true,
    });
  }

  addRequestNote(note): void {
    const body: MedicalRequestNotes = {
      requestId: this.request.id,
      notes: note,
    };
    this.medicalRequestService
      .updateMedicationRequest(body)
      .subscribe((res) => {
        this.modalService.dismissAll();
        this.request.notes = note;
      });
  }

  cancelClicked(event) {
    event.stopPropagation();
    this.onCancelRequest();
  }

  hasReceiptDocument(): boolean {
    return (
      this.request.receiptImage !== null && this.request.receiptImage !== ''
    );
  }

  onReceiptDocumentButtonClick(event: MouseEvent): void {
    // Prevent from navigating to the patient details page
    event.preventDefault();
    event.stopPropagation();

    const modalRef = this.modalService.open(PreviewDocumentsModalComponent);
    modalRef.componentInstance.filesUrls = [this.request.receiptImage];
  }

  hasSerialNumberDocument(): boolean {
    return (
      this.request.boxes && this.request.boxes.some((box) => box.imagePath)
    );
  }

  onSerialNumberDocumentButtonClick(event: MouseEvent): void {
    // Prevent from navigating to the patient details page
    event.preventDefault();
    event.stopPropagation();

    const modalRef = this.modalService.open(PreviewDocumentsModalComponent);
    const boxesImages = this.request.boxes.map((box) => box.imagePath);
    modalRef.componentInstance.filesUrls = boxesImages;
  }

  getBoxesTooltip(boxes: MedicalRequestBox[]): string {
    if (!boxes || boxes.length === 0) return '';
    
    return boxes.map((box, index) => 
      `Pack ${index + 1} Serial number: ${box.serialNumber}`
    ).join('<br>');
  }

  onCancelRequest() {
    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered',
      initialState: {
        title: 'Test Request Files',
        subtitle: `Please upload test request results below by dragging the file or clicking upload files.`,
      },
    };

    this.modalRef = this.bsModalService.show(
      CancelRequestModalComponent,
      initialState
    );

    this.modalRef.content.event.subscribe((cancellationReasonResponse) => {
      this.modalRef.hide();
      this.medicalRequestService
        .cancelMedicationRequest(
          this.request.id,
          cancellationReasonResponse.cancellationReason
        )
        .subscribe((res) => {
          if (res.data.flag) {
            this.request.statusId = 5;
            this.request.canCancel = false;
            showNotification(
              'success',
              'The request has been cancelled successfully.',
              this.toastr
            );
          }
        });
    });
  }
}
